
<template>
    <div class="mian">
        <div class="banner">
            <img class="banner-img" :src="'https://cdn.zxzx119.com/zxzx-h5/activity/carEmergency/pc-banner.png?date='+date" alt="" srcset="">
        </div>
        <div class="content">
            <img class="content-img" style="padding: 0 20px;" :src="'https://cdn.zxzx119.com/zxzx-h5/activity/carEmergency/pc-img1.png?date='+date" alt="" srcset="">
            <div class="comm">
                <img class="comm-img" :src="'https://cdn.zxzx119.com/zxzx-h5/activity/carEmergency/pc-img2.png?date='+date" alt="" srcset="">

                <img class="comm-btn" @click="postMsg(14011)" :src="'https://cdn.zxzx119.com/zxzx-h5/activity/carEmergency/pc-btn.png?date='+date" alt="" srcset="">
            </div>
            <div class="comm comm2" style="padding-bottom: 30px;">
                <img class="comm-img" :src="'https://cdn.zxzx119.com/zxzx-h5/activity/carEmergency/pc-img3.png?date='+date" alt="" srcset="">

                <img class="comm-btn" @click="postMsg(14012)" :src="'https://cdn.zxzx119.com/zxzx-h5/activity/carEmergency/pc-btn.png?date='+date" alt="" srcset="">
            </div>
        </div>
        
    </div>
</template>
<script>
export default {
    name:'',
    components: {
    },
    data () {
        return {
         date :"",
        }
    },
    created () {
          this.date = new Date().getTime()
    },
    methods: {
        postMsg(num) {
            window.open('https://www.zxmall119.com/goodscompany/26359?id=' + num)
        }
    },
    mounted () {
        
    },
}

</script>


<style lang='scss' scoped>
.mian{
    background: url(https://cdn.zxzx119.com/zxzx-h5/activity/carEmergency/bj.png);
}
.banner{
    width: 100%;
    .banner-img{
        width: 100%;
        height: 100%;
    }

}
.content{
    width: 550px;
    margin: auto;
    text-align: center;
     padding: 0 5px;
    .comm{
        width: 100%;
        margin-top: 25px;
        position: relative;
        padding: 0 20px;
        .comm-img{
            width: 100%;
        }
        .comm-btn{
            position: absolute;
            top: 15%;
            right: 0%;
            transform: translate(-50%,-50%);
            width: 95px;

        }
    }
    .comm2{
         .comm-btn{
            position: absolute;
            top: 12%;
            right: 0%;
            transform: translate(-50%,-50%);
            width: 95px;
        }
    }
    .content-img{
        width: 100%;
    }
    .content-btn{
        width: 125px;
    }
}
</style>


// WEBPACK FOOTER //
// src/view/activity/carEmergency/index-pc.vue